/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Paste_New_TokenInputs */

const en_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste new token`)
};

const fr_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller le nouveau jeton`)
};

const de_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Token einfügen`)
};

const it_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla il nuovo token`)
};

const ru_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте новый токен`)
};

const es_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar nuevo token`)
};

const zh_cn2_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴新令牌`)
};

const ja_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいトークンを貼り付ける`)
};

const hi_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया टोकन पेस्ट करें`)
};

const pt_pt2_live_caption_paste_new_token = /** @type {(inputs: Live_Caption_Paste_New_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o novo token`)
};

/**
* | output |
* | --- |
* | "Paste new token" |
*
* @param {Live_Caption_Paste_New_TokenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_paste_new_token = /** @type {((inputs?: Live_Caption_Paste_New_TokenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Paste_New_TokenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_paste_new_token(inputs)
	if (locale === "de") return de_live_caption_paste_new_token(inputs)
	if (locale === "it") return it_live_caption_paste_new_token(inputs)
	if (locale === "ru") return ru_live_caption_paste_new_token(inputs)
	if (locale === "es") return es_live_caption_paste_new_token(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_paste_new_token(inputs)
	if (locale === "ja") return ja_live_caption_paste_new_token(inputs)
	if (locale === "hi") return hi_live_caption_paste_new_token(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_paste_new_token(inputs)
	return en_live_caption_paste_new_token(inputs)
});